import delve from 'dlv';

/** This returns the displayName of a specific breakdown.
 *  The breakdownItems parameter should come from the API */
export default (
  key: string | number | undefined,
  breakdownItems: any[] | undefined
): string | null => {
  if (!key || !breakdownItems) {
    return null;
  }

  const breakdown = breakdownItems.find((el: any) => {
    return el.id === key || el.name === key;
  });

  return delve(breakdown, 'displayName') || delve(breakdown, 'label') || null;
};
